import React, { useState, useEffect } from 'react';
//import { SecureRoute, Security, LoginCallback } from '@okta/okta-react';
//import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
//import { BrowserRouter as Router, Route, useHistory, Redirect } from 'react-router-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
//import { oktaAuthConfig } from "./okta_config";
import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate, useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from './authConfig';
import AuthEntraId from './auth/AuthEntraId'

import LoginForm from './auth/LoginForm';
//import AuthOkta from './auth/AuthOkta';
import DashboardPage from './autorenew/dashboard/DashboardPage';
import OrderStatusPage from './autorenew/orderstatus/OrderStatusPage';
import BankFileStatusPage from './autorenew/bankfilestatus/BankFileStatusPage';
import BankFileApprovalPage from './autorenew/bankfileapproval/BankFileApprovalPage';
import UserManagement from './user/UserManagement';
import RoleManagement from './user/RoleManagement';
import SaleSummaryReportPage from './report/salesummary/SaleSummaryReportPage';
import OrderPaymentReconcilePage from './report/reconcile/OrderPaymentReconcilePage';
import MagicEOMReconcilePage from './report/magiceom/MagicEOMReconcilePage';
import MagicEOMDetailPage from './report/magiceom/MagicEOMDetailPage';
import EBankingPage from './onlinepayment/ebanking/EBankingPage'
import GatewayPage from './onlinepayment/gateway/GatewayPage'
import DownloadStatusPage from './onlinepayment/download/DownloadStatusPage'
import BankAccountPage from './setting/bankaccount/BankAccountPage'
import LogoutPage from './auth/LogoutPage';
import UnauthorizePage from './auth/UnauthorizePage'

/**
* msal-react is built on the React context API and all parts of your app that require authentication must be 
* wrapped in the MsalProvider component. You will first need to initialize an instance of PublicClientApplication 
* then pass this to MsalProvider as a prop. All components underneath MsalProvider will have access to the 
* PublicClientApplication instance via context as well as all hooks and components provided by msal-react. For more, visit:
* https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
*/
const App = ({ instance }) => {
    /**
    * useMsal is hook that returns the PublicClientApplication instance,
    * that tells you what msal is currently doing. For more, visit:
    * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
    */
    //const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const handleLogoutRedirect = () => {
        instance.logoutRedirect().catch((error) => console.log(error));
    };
    //     const handleLoginRedirect = () => {
    //         instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    //     };

    // const handleRedirect = () => {
    //     setIsLogin(true)

    //     instance
    //         .loginRedirect({
    //             ...loginRequest,
    //             prompt: 'create',
    //         })
    //         .catch((error) => console.log(error));
    // };

    return (
        <MsalProvider instance={instance}>
            <BrowserRouter>

                <Routes>
                    <Route path="/auth/logout" element={<LogoutPage />} />
                    <Route path="/auth/unauthorize" element={<UnauthorizePage />} />
                    <Route path="/auth/login" element={<LoginForm />} />
                    <Route path="/login/callback" element={<AuthEntraId />} />
                    <Route path="/" element={<AuthEntraId />} />

                    <Route path="/autorenew/dashboard" element={
                        <AuthenticatedTemplate>
                            <DashboardPage />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/autorenew/orderstatus" element={
                        <AuthenticatedTemplate>
                            <OrderStatusPage />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/autorenew/bankfilestatus" element={
                        <AuthenticatedTemplate>
                            <BankFileStatusPage />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/autorenew/bankfileapproval" element={
                        <AuthenticatedTemplate>
                            <BankFileApprovalPage />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/user/usermanagement" element={
                        <AuthenticatedTemplate>
                            <UserManagement />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/user/rolemanagement" element={
                        <AuthenticatedTemplate>
                            <RoleManagement />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/report/salesummary" element={
                        <AuthenticatedTemplate>
                            <SaleSummaryReportPage />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/report/orderpaymentreconcile" element={
                        <AuthenticatedTemplate>
                            <OrderPaymentReconcilePage />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/report/magiceom" element={
                        <AuthenticatedTemplate>
                            <MagicEOMReconcilePage />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/report/magiceomdetail" element={
                        <AuthenticatedTemplate>
                            <MagicEOMDetailPage />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/onlinepayment/ebanking" element={
                        <AuthenticatedTemplate>
                            <EBankingPage />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/onlinepayment/gateway" element={
                        <AuthenticatedTemplate>
                            <GatewayPage />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/onlinepayment/downloadstatus" element={
                        <AuthenticatedTemplate>
                            <DownloadStatusPage />
                        </AuthenticatedTemplate>
                    } />
                    <Route path="/setting/bankaccount" element={
                        <AuthenticatedTemplate>
                            <BankAccountPage />
                        </AuthenticatedTemplate>
                    } />

                </Routes>
            </BrowserRouter>
        </MsalProvider>
    );
};

export default App;

/*
const oktaAuth = new OktaAuth(oktaAuthConfig);
// const oktaAuth = new OktaAuth({
//         issuer: `${process.env.REACT_APP_OKTA_BASE_URL}/oauth2/default`,
//         clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
//         redirectUri: window.location.origin + '/login/callback',
//         scopes: ["openid", "profile", "email"],
//         pkce: true,
//       });

const App = () => {
        const history = useHistory();
        const restoreOriginalUri = async (_oktaAuth, originalUri) => {
                history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
        };

        return (
                <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
                        <Route path="/" exact={true}>
                                <Redirect to="/auth/okta" />
                        </Route>
                        <Route path="/login/callback" component={LoginCallback} />
                        <Route path="/UAT/login/callback" component={LoginCallback} />
                        <Route path="/auth/logout" component={LogoutPage} />
                        <Route path="/auth/unauthorize" component={UnauthorizePage} />

                        <Route path="/auth/login" component={LoginForm} />
                        <SecureRoute path="/auth/okta" component={AuthOkta} />
                        <SecureRoute path="/autorenew/dashboard" component={DashboardPage} />
                        <SecureRoute path="/autorenew/orderstatus" component={OrderStatusPage} />
                        <SecureRoute path="/autorenew/bankfilestatus" component={BankFileStatusPage} />
                        <SecureRoute path="/autorenew/bankfileapproval" component={BankFileApprovalPage} />
                        <SecureRoute path="/user/usermanagement" component={UserManagement} />
                        <SecureRoute path="/user/rolemanagement" component={RoleManagement} />
                        <SecureRoute path="/report/salesummary" component={SaleSummaryReportPage} />
                        <SecureRoute path="/report/orderpaymentreconcile" component={OrderPaymentReconcilePage} />
                        <SecureRoute path="/report/magiceom" component={MagicEOMReconcilePage} />
                        <SecureRoute path="/report/magiceomdetail" component={MagicEOMDetailPage} />
                        <SecureRoute path="/onlinepayment/ebanking" component={EBankingPage} />
                        <SecureRoute path="/onlinepayment/gateway" component={GatewayPage} />
                        <SecureRoute path="/onlinepayment/downloadstatus" component={DownloadStatusPage} />
                        <SecureRoute path="/setting/bankaccount" component={BankAccountPage} />

                </Security>
        );
};

const AppWithRouterAccess = () => (
        <Router>
                <App />
        </Router>
);

export default AppWithRouterAccess;
*/